import * as React from 'react';

import type { SupplierConditionsClient } from '@/api/supplier-conditions-client';
import { HttpSupplierConditionsClient } from '@/api/supplier-conditions-client.http';

// =============================================================================
// supplier-conditions-client-context.tsx — Injection du SupplierConditionsClient (DI seam, DBU §3.3, F2).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut : l'adaptateur HTTP RÉEL
// (HttpSupplierConditionsClient) — le BACK conditions fournisseur est livré (F2). Câblé HTTP DÈS LE DÉPART
// (garde 09_stub_in_prod_guard : aucun défaut stub-en-prod). Les tests de composant injectent un
// StubSupplierConditionsClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultSupplierConditionsClient: SupplierConditionsClient =
  new HttpSupplierConditionsClient();

const SupplierConditionsClientContext =
  React.createContext<SupplierConditionsClient>(defaultSupplierConditionsClient);

export interface SupplierConditionsClientProviderProps {
  client?: SupplierConditionsClient | undefined;
  children: React.ReactNode;
}

export function SupplierConditionsClientProvider({
  client = defaultSupplierConditionsClient,
  children,
}: SupplierConditionsClientProviderProps): React.JSX.Element {
  return (
    <SupplierConditionsClientContext.Provider value={client}>
      {children}
    </SupplierConditionsClientContext.Provider>
  );
}

export function useSupplierConditionsClient(): SupplierConditionsClient {
  return React.useContext(SupplierConditionsClientContext);
}
